import { useParams } from 'react-router-dom'

import { useArticleDetailApi } from '@/common/api/modules/articles'
import { useSiteGetApi } from '@/common/api/modules/site'
import { useSiteId } from '@/common/app/site'

import Main, { MainLayoutType } from '@/components/view/layouts/page/Main'

import DetailPageLoader from '@/components/container/DetailPageLoader'
import ArticleEditForm from '@/components/container/form/modules/media/article/ArticleEditForm'
import ArticleDiagnosisModalProvider from '@/components/container/modal/article/ArticleDiagnosisModalProvider'
import ArticleDiffModalProvider from '@/components/container/modal/article/ArticleDiffModalProvider'
import ArticleRewriteModalProvider from '@/components/container/modal/article/ArticleRewriteModalProvider'

// 記事編集(既存記事)：特集記事概要・コンテンツブロックをその場で直接編集して保存する
const ArticleUpdatePage = () => {
  const siteId = useSiteId()
  const { articleId } = useParams()
  const articleProposalId = Number(articleId)

  const { data: site } = useSiteGetApi({ site_id: siteId })
  const { data, error, mutate } = useArticleDetailApi(
    articleId ? { site_id: siteId, article_proposal_id: articleProposalId } : null
  )

  return (
    <DetailPageLoader error={error} data={data}>
      {data && (
        <ArticleDiagnosisModalProvider>
          <ArticleRewriteModalProvider>
            <ArticleDiffModalProvider>
              <Main type={MainLayoutType.MEDIUM}>
                <ArticleEditForm
                  siteId={siteId}
                  articleProposalId={articleProposalId}
                  detail={data}
                  enableArticleUpload={!!site?.enable_article_upload}
                  onSaved={() => mutate()}
                />
              </Main>
            </ArticleDiffModalProvider>
          </ArticleRewriteModalProvider>
        </ArticleDiagnosisModalProvider>
      )}
    </DetailPageLoader>
  )
}

export default ArticleUpdatePage
